import layout from './ModalDetailViewWindow.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import Window from '@/Controls/Window';
import ModalDetailViewWindowViewModel from '@/Components/ModalDetailView/ModalDetailViewWindowViewModel';

export default class ModalDetailViewWindow extends Window {

    /**
     * Anmerkung: Beim Schließen der Fenster prüft Kendo, ob das Overlay der modalen Fenster geschlossen werden kann.
     * Hierfür wird ermittelt ob noch weitere modale Fenster offen sind. Bei der Prüfung werden die "appendTo"-Eigenschaften der
     * modalen Fenster miteinander verglichen. Es muss jedes Mal der identische Selektor hineingeben werden, daher ist der Selektor
     * statisch und wird nicht jedes Mal beim Erzeugen eines Fensters erzeugt.
     */
    private static BODY = $('body');;

    public constructor(viewModel: ModalDetailViewWindowViewModel, element?: JQuery, customLayout?: string) {
        let $element = element || $('<div>');
        super(viewModel, $element);

        this.applyTemplate(customLayout || layout, $element);
    }

    /**
     * @override
     * @inheritdoc
     */
    protected onWidgetCreatedCallback(widget: any): void {
        super.onWidgetCreatedCallback(widget);
        this.applyBindings(widget.wrapper,
            {
                controlName: 'modaldetailviewwindow'
            });
    }

    /**
     * @override
     */
    protected getElementToAppended(): JQuery {
        return ModalDetailViewWindow.BODY;
    }
}

ComponentManager.setControl('ModalDetailViewWindow', ModalDetailViewWindow, 'RADPresentation.HTMLClient.DefaultViewExtensions');